<script>
import {ProductBreadcrumbs} from "@core/domain/product";
import { BBreadcrumb, BBreadcrumbItem, BLink } from 'bootstrap-vue'

export default {
    components: {BBreadcrumb, BBreadcrumbItem, BLink},
    data() {
        return {
            items: ProductBreadcrumbs.getItems()
        }
    }
}
</script>

<template>
        <b-breadcrumb>
            <b-breadcrumb-item :active="index === items.length - 1" v-for="(item, index) in items">
                <b-link
                    @click="item.click()"
                    v-if="index !== items.length - 1"
                >
                    {{ item.title }}
                </b-link>
                <span v-else>{{ item.title }}</span>
            </b-breadcrumb-item>
        </b-breadcrumb>
</template>
